import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/** 2019/4/1
 *@author:Matt
 *@desc：路由懒加载
 */
export const routerMap = [
  { path: '/', component: () => import('@/components/Home'), hidden: true },
  { path: '/Login', component: () => import('@/components/Login'), hidden: true },
  { path: '/EffectiveLoan', component: () => import('@/components/EffectiveLoan'), hidden: true },
  { path: '/AboutUS', component: () => import('@/components/AboutUS'), hidden: true },
  { path: '/HelpCenter', component: () => import('@/components/HelpCenter'), hidden: true },
  { path: '/PartnerLoan', component: () => import('@/components/PartnerLoan'), hidden: true },
  { path: '/GoldEasyLoan', component: () => import('@/components/GoldEasyLoan'), hidden: true },
  { path: '/Mortgage', component: () => import('@/components/Mortgage'), hidden: true },
  { path: '/PersonalLoan', component: () => import('@/components/PersonalLoan'), hidden: true },
  { path: '/FreightLoan', component: () => import('@/components/FreightLoan'), hidden: true },
  { path: '/*', component: () => import('@/components/Home'), hidden: true },
];

export default new Router({
  // mode: 'history', // require service support
  routes: routerMap,
});
